import { request } from '../request'

export function search(query) {
  return request(`/kinds.json?query=${query}`)
}

export function find(id) {
  return request(`/kinds/${id}.json`)
}
